import type { FC } from 'react';

type Props = { iconColor?: string; bgColor?: string; className?: string };

export const WAmazingIcon: FC<Props> = ({ bgColor = 'white', iconColor = '#E91E63', className }) => {
  return (
    <svg
      className={className}
      width="39"
      height="36"
      viewBox="0 0 39 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.000244141" y="0.148926" width="38.9321" height="35.7026" rx="4" fill={iconColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.539 15.886C18.8493 15.3558 19.5303 15.1705 20.0648 15.4808C20.2416 15.5843 20.3838 15.7308 20.4786 15.8946L24.4312 22.7351L27.1941 17.955L26.7631 17.2136L20.8278 6.94203C20.539 6.43772 20.0347 6.14893 19.4571 6.14893C18.8795 6.14893 18.3752 6.43772 18.0864 6.94203L12.151 17.2136L11.7717 17.8688L14.5864 22.7394L18.5476 15.8903L18.539 15.886Z"
        fill={bgColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7244 27.4808L28.5002 20.1747L25.4485 25.4549C25.3537 25.6445 25.2071 25.8083 25.0089 25.9204C24.4744 26.2308 23.7933 26.0454 23.483 25.5152L19.5261 18.6704L15.5649 25.5152C15.4701 25.679 15.3321 25.8213 15.1554 25.9204C14.6209 26.2264 13.9399 26.0411 13.6339 25.5109L10.4959 20.0842L6.22007 27.4764C5.92697 27.9808 5.92697 28.554 6.22007 29.0583C6.51318 29.5627 7.00886 29.8514 7.59076 29.8514H31.3408C31.9227 29.8514 32.4227 29.5627 32.7158 29.0583C33.0046 28.554 33.0046 27.9808 32.7158 27.4764"
        fill={bgColor}
      />
    </svg>
  );
};
